import { Component, OnInit, ComponentFactoryResolver } from '@angular/core';
import { GenerateClientApplicationNumberDataEntity } from '../../../../../models/data-entities/client-app-number-data-entity';
import { DataEntityViewComponent } from '../../data-entity-view/data-entity-view.component';
import { WorkflowContextService } from 'src/app/services';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'wm-client-app-number-data-entity-view',
    templateUrl: './client-app-number-data-entity-view.component.html',
    styleUrls: ['./client-app-number-data-entity-view.component.css'],
    standalone: false
})
export class GenerateClientApplicationNumberDataEntityViewComponent
  extends DataEntityViewComponent
  implements OnInit {
  constructor(public layoutService: LayoutService, componentFactoryResolver: ComponentFactoryResolver, context: WorkflowContextService) {
    super(layoutService, componentFactoryResolver, context);
  }
  public entity: GenerateClientApplicationNumberDataEntity;

  ngOnInit() {
    this.entity = <GenerateClientApplicationNumberDataEntity>this.entity;
  }
}
